module.exports = __webpack_public_path__ + "static/media/cofina.a9eb039d.webp";